import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommKitIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M9 1.25C8.58579 1.25 8.25 1.58579 8.25 2V4.25H8C7.58579 4.25 7.25 4.58579 7.25 5V7.35352C6.30842 7.61983 5.57213 8.3751 5.33278 9.32768C5.2325 9.27796 5.11952 9.25 5 9.25H3C2.58579 9.25 2.25 9.58579 2.25 10V12H2C1.44772 12 1 12.4477 1 13V22C1 22.5523 1.44772 23 2 23H5.75C6.0811 23 6.37461 22.8391 6.55661 22.5912C6.97616 22.8504 7.47061 23 8 23H20C21.1046 23 22 22.1046 22 21V14C22 12.8954 21.1046 12 20 12H18.75V10C18.75 9.58579 18.4142 9.25 18 9.25H16.6465C16.3875 8.33416 15.6658 7.61255 14.75 7.35352V5C14.75 4.58579 14.4142 4.25 14 4.25H13.75V2C13.75 1.58579 13.4142 1.25 13 1.25H9ZM17.25 12V10.75H14.75V12H17.25ZM13.25 12V10C13.25 9.58579 13.5858 9.25 14 9.25H15.0001C14.772 8.94639 14.409 8.75 14 8.75H8C7.30964 8.75 6.75 9.30964 6.75 10V20.25C6.75 20.9404 7.30964 21.5 8 21.5H10.063C10.0219 21.3402 10 21.1726 10 21V14C10 12.8954 10.8954 12 12 12H13.25ZM12 21.5H20C20.2761 21.5 20.5 21.2761 20.5 21V14C20.5 13.7239 20.2761 13.5 20 13.5H12C11.7239 13.5 11.5 13.7239 11.5 14V21C11.5 21.2761 11.7239 21.5 12 21.5ZM12.25 4.25V2.75H9.75V4.25H12.25ZM13.25 7.25V5.75H8.75V7.25H13.25ZM5.25 13.5V21.5H2.5V13.5H5.25ZM4.25 10.75V12H3.75V10.75H4.25Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
